import Tableros from '../views/Configuracion/Tableros'
import TablerosLinks from '../views/Configuracion/TablerosLinks'
import Areas from '../views/Configuracion/Areas'
import EmpresasGroupCard from '../views/Configuracion/EmpresaGrupoCard'
import Empresas from '../views/Configuracion/Empresas'
import UsuariosConfig from '../views/Seguridades_BI/Usuarios'
import RolesConfig from '../views/Seguridades_BI/Roles'
import Grupos from '../views/Configuracion/Grupos'
import AreasCreateEdit from '../views/Configuracion/AreasCreateEdit'
import DashboardView from '../views/Dashboard/DashboardView'
import Usuarios from '../views/Seguridades/Usuarios'
import Roles from '../views/Seguridades/Roles'
import AreaCard from '../views/General/AreaCard'
import TableroDetails from '../views/General/TableroDetails'
import TableroDetailsBI from '../views/General/TableroDetailsBI'
import ChatAI from '../views/General/ChatAI'
import '../environments/envionments'

const routes = [

  // coonfiguracion 
  { path: global.TABLERO, exact: true, name: 'Tableros', element: Tableros },
  { path: global.TABLERO_LINK, exact: true, name: 'Tableros Links', element: TablerosLinks },
  { path: global.AREAS, exact: true, name: 'Areas', element: Areas },
  { path: global.AREAS_CREATE, exact: true, name: 'AREAS_CREATE', element: AreasCreateEdit },
  { path: global.EMPGROUPCARD_CREATE, exact: true, name: 'EMPRESAS_CREATE', element: EmpresasGroupCard },
  { path: global.EMPRESAS_CREATE, exact: true, name: 'EMPRESAS_CREATE', element: Empresas },
  { path: global.GRUPOS_CREATE, exact: true, name: 'GRUPOS_CREATE', element: Grupos },

  // General
  { path: global.TABLERO_LIST, exact: true, name: 'AreaCard', element: AreaCard },
  { path: global.TABLERO_DETAIL, exact: true, name: 'TableroDetails', element: TableroDetails },
  { path: global.TABLERO_DETAILBI, exact: true, name: 'TableroDetailsBI', element: TableroDetailsBI },
  { path: global.ChatAI, exact: true, name: 'ChatAI', element: ChatAI },

  // Dashboard
  { path: global.DASHBOARD, exact: true, name: 'DashboardView', element: DashboardView },

  // Seguridades
  { path: global.USUARIOS, exact: true, name: 'Usuarios', element: Usuarios },
  { path: global.ROLES, exact: true, name: 'Roles', element: Roles },

   // Seguridades BI
  { path: global.SECURE_USERSBI, exact: true, name: 'USUARIOS_CREATE', element: UsuariosConfig },
  { path: global.SECURE_ROLESNI, exact: true, name: 'Roles', element: RolesConfig },


]

export default routes
